var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dropdown-menu dm-notice pull-right",
      on: {
        scroll: function($event) {
          return _vm.handleScroll($event)
        }
      }
    },
    [
      _c("div", { staticClass: "tab-content" }, [
        _c(
          "ul",
          { staticClass: "list-group notice-list" },
          [
            _vm.listNotification.length > 0
              ? _vm._l(_vm.listNotification, function(notif) {
                  return _c(
                    "li",
                    {
                      key: notif.id,
                      staticClass: "list-group-item",
                      on: {
                        click: function($event) {
                          return _vm.onReadNotification(notif)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _vm._m(0, true),
                        _c("div", { staticClass: "col-xs-10" }, [
                          _c("h5", [
                            _c("a", {
                              class: {
                                "text-danger": notif.message.includes("[Chú ý]")
                              },
                              attrs: { href: "javascript: void(0)" },
                              domProps: { innerHTML: _vm._s(notif.message) }
                            })
                          ]),
                          _c(
                            "small",
                            {
                              class: {
                                "text-danger": notif.message.includes("[Chú ý]")
                              }
                            },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm._f("formatDate")(
                                    notif.createdDate,
                                    "DD-MM-YYYY HH:mm:ss"
                                  )
                                )
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  )
                })
              : _vm._e(),
            !_vm.listNotification.length > 0 && !_vm.isLoading
              ? [
                  _c(
                    "li",
                    { staticClass: "list-group-item text-danger fb item-no" },
                    [
                      _vm._v(
                        "\n                    Không tìm thấy thông báo!\n                "
                      )
                    ]
                  )
                ]
              : _vm._e()
          ],
          2
        )
      ]),
      _c(
        "div",
        { staticClass: "view-more" },
        [
          _c("router-link", { attrs: { to: { name: "notification" } } }, [
            _vm._v("Xem thêm")
          ])
        ],
        1
      ),
      _vm.isLoading
        ? _c("div", { staticClass: "loading" }, [
            _c("div", { staticClass: "loader" })
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-xs-2" }, [
      _c("i", { staticClass: "fa fa-comments" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }